import { render } from "./ProductsReportListComponent.vue?vue&type=template&id=26f5af8a&scoped=true"
import script from "./ProductsReportListComponent.vue?vue&type=script&lang=js"
export * from "./ProductsReportListComponent.vue?vue&type=script&lang=js"

import "./ProductsReportListComponent.vue?vue&type=style&index=0&id=26f5af8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f5af8a"],['__file',"resources/js/components/admin/productsReport/ProductsReportListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26f5af8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26f5af8a', __exports__)) {
    api.reload('26f5af8a', __exports__)
  }
  
  module.hot.accept("./ProductsReportListComponent.vue?vue&type=template&id=26f5af8a&scoped=true", () => {
    api.rerender('26f5af8a', render)
  })

}


export default __exports__